<template>
	<div class="summary-block flex items-start justify-between gap-4 w-fit bg-shade-2 border border-subtle p-4 relative">
		<slot />
		<CTooltip
			:use-button="false"
			class="relative -top-3 -right-3"
		>
			<template #button>
				<CIconButton
					icon="edit"
					:intense="false"
					:aria-label="editTitle"
					@click="$emit('edit')"
				/>
			</template>
			{{ editTitle }}
		</CTooltip>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CIconButton from 'src/components/interaction/IconButton.vue';
	import CTooltip from 'src/components/interaction/ToolTip.vue';

	export default defineComponent({
		name: 'CSummaryBlock',
		components: {
			CIconButton,
			CTooltip
		},
		props: {
			editTitle: {
				type: String,
				default: 'Edit'
			}
		},
		emits: ['edit']
	});
</script>

<style lang="scss">
.summary-block {
	min-width: min(340px, 100%);
}
</style>
